module.exports = __webpack_public_path__ + "img/diploma.335f4faf.jpg";